export var ChatMessageUserScoreType;
(function (ChatMessageUserScoreType) {
    ChatMessageUserScoreType["Positive"] = "Positive";
    ChatMessageUserScoreType["Negative"] = "Negative";
})(ChatMessageUserScoreType || (ChatMessageUserScoreType = {}));
export class ChatThreadMessage {
    constructor(model) {
        var _a, _b, _c;
        this.id = model.id;
        this.threadId = model.threadId;
        this.payload = model.payload;
        this.createdAt = model.createdAt ? new Date(model.createdAt) : new Date();
        this.updatedAt = model.updatedAt ? new Date(model.updatedAt) : new Date();
        this.sender = model.sender;
        this.userScore = model.userScore
            ? {
                type: (_a = model.userScore) === null || _a === void 0 ? void 0 : _a.type,
                tags: (_b = model.userScore) === null || _b === void 0 ? void 0 : _b.tags,
                comment: (_c = model.userScore) === null || _c === void 0 ? void 0 : _c.comment,
            }
            : undefined;
    }
    toRemote() {
        return {
            id: this.id,
            threadId: this.threadId,
            payload: this.payload,
            createdAt: this.createdAt,
            updatedAt: this.updatedAt,
            sender: this.sender,
        };
    }
}
